/* eslint-disable eqeqeq */
import React from "react";
import { useDispatch } from "react-redux";
import { updateRequest } from "../../../Redux/Slices/requests.slice";
import ArrowIcon from "../../../Common/Svgs/ArrowIcon";
import { updateRental } from "../../../Redux/Slices/rentals.slice";

const RequestDetailCTA = ({ rental }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(updateRental({ key: "currentRental", value: rental }));

    dispatch(
      updateRequest({
        key: "requestDetailsVisible",
        value: true,
      }),
    );
  };

  return (
    <button
      type="button"
      className="w-8 h-6 bg-green-10 rounded-md py-1 px-2"
      onClick={onClick}
    >
      <div className="rotate-90">
        <ArrowIcon className="rotate-90 text-green" />
      </div>
    </button>
  );
};

export default RequestDetailCTA;
